// AUTO-GENERATED by scripts/build-social-hooks.mjs — do not edit by hand.
// Source: hooks/*.md  ·  Regenerate: node scripts/build-social-hooks.mjs
// Picker metadata only; full formulas are server-side in api/_lib/socialHooks.js.
export const SOCIAL_HOOK_CATEGORIES = [
  {
    "id": "curiosity",
    "label": "Curiosity",
    "description": "Open loops the brain can't leave alone"
  },
  {
    "id": "storytelling",
    "label": "Storytelling",
    "description": "Scene-setting, narrative tension, specific moments"
  },
  {
    "id": "authority",
    "label": "Authority",
    "description": "Experience-backed, credibility through specificity"
  },
  {
    "id": "relatable",
    "label": "Relatable",
    "description": "\"Is it just me?\" moments — make her feel seen"
  },
  {
    "id": "shock",
    "label": "Shock & Discovery",
    "description": "Counterintuitive findings, surprising reframes"
  },
  {
    "id": "humor",
    "label": "Humor & Wit",
    "description": "Deadpan observation, understatement that lands"
  },
  {
    "id": "inspirational",
    "label": "Inspirational",
    "description": "Witness rather than cheer — validate without hype"
  },
  {
    "id": "scrollstoppers",
    "label": "Scroll Stoppers",
    "description": "Short, specific, immediate pattern interrupts"
  },
  {
    "id": "listbased",
    "label": "List-Based",
    "description": "Specific numbered promises that feel curated"
  }
];
